import { Component, computed, inject, input, output, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Dialog } from '@angular/cdk/dialog';
import { firstValueFrom } from 'rxjs';
import { RestService } from '@cumlaude/shared-services';
import { ToastrService } from '@cumlaude/shared-components-toast';
import { MeatballMenuComponent, MeatballMenuItemComponent } from '@cumlaude/shared-components-menu';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { GedeeldePaginaDialogComponent } from '../../../dialogs/pagina-delen/gedeelde-pagina-dialog/gedeelde-pagina-dialog.component';
import { GedeeldePaginaPersoonGroep, GedeeldePaginaPersoonMode } from '../gedeelde-pagina-persoon.model';

@Component({
	selector: 'app-bericht-rij',
	templateUrl: './bericht-rij.component.html',
	styleUrl: './bericht-rij.component.scss',
	imports: [MeatballMenuComponent, MeatballMenuItemComponent, DatePipe, IconComponent],
})
export class BerichtRijComponent {
	protected readonly dialog = inject(Dialog);
	private readonly toastr = inject(ToastrService);
	private readonly restService = inject(RestService);

	readonly mode = input.required<GedeeldePaginaPersoonMode>();
	readonly value = input.required<GedeeldePaginaPersoonGroep>();

	refresh = output();

	readonly hover = signal(false);
	readonly menuOpened = signal(false);
	readonly isInbox = computed(() => this.mode() === GedeeldePaginaPersoonMode.INBOX);
	readonly meatballVisible = computed(() => this.isInbox() && (this.hover() || this.menuOpened()));

	readonly openLabel = computed(() => `${this.isInbox() ? 'Ontvangen bericht van' : 'Verzonden bericht aan'} ${this.value().naam}`);

	async openGedeeldePaginaPersoonDialog(gedeeldePaginaPersoonGroep: GedeeldePaginaPersoonGroep) {
		const dialogRef = this.dialog.open<void>(GedeeldePaginaDialogComponent, { data: { gedeeldePaginaPersoon: gedeeldePaginaPersoonGroep } });
		await firstValueFrom(dialogRef.closed);
		this.refresh.emit();
	}

	async delete(gedeeldePaginaPersoonGroep: GedeeldePaginaPersoonGroep) {
		if (!this.isInbox()) return;

		try {
			await firstValueFrom(this.restService.deleteGedeeldePaginaPersoon(gedeeldePaginaPersoonGroep.primary));
			this.refresh.emit();
		} catch (err) {
			this.toastr.error('Verwijderen is mislukt.');
		}
	}
}
